<template>
  <v-btn dark :block="block" :outlined="outlined" @click="logoutClicked">
    <v-icon dense left>mdi-logout</v-icon>
    Logout
  </v-btn>
</template>

<script>
import { mapActions } from "vuex";
import iziToast from "izitoast/dist/js/iziToast.min.js";

export default {
  props: {
    outlined: Boolean,
    block: Boolean,
  },
  methods: {
    ...mapActions("app", ["logout"]),
    async logoutClicked() {
      try {
        // Sign out from AWS Amplify first
        await this.$authentication.signOut();

        // Clear all application state and localStorage
        await this.logout();

        // Navigate to login page
        this.$router.push({
          path: "/login",
          query: {
            redirect: "/",
          },
        });

        iziToast.success({
          title: "Success",
          message: "You have been logged out successfully",
        });
      } catch (err) {
        console.error("Logout error:", err);
        iziToast.error({
          title: "Error",
          message: "An error occurred during logout. Please try again.",
        });
      }
    },
  },
};
</script>

<style></style>
